export default "__VITE_ASSET__CYGrafnr__"